import type { CSS } from '../theme';

export const popover: CSS = {
  display: 'flex',
  position: 'absolute',
  width: '100%',
  backgroundColor: '$white',
  zIndex: 100,
};
